import { GENERATE_UPLOAD_LINK_RESOLUTION_DOCUMENT } from "..";
import { apiInstance } from "../config/apiInstance";

export type GenerateUploadLinkResolutionDocumentRequest = {
  fileName: string[];
};

export type ResolutionDocumentUploadLinkResponse = {
  id: number;
  link: string;
  originalName: string;
};

export const generateUploadLinkResolutionDocument = async (
  data: GenerateUploadLinkResolutionDocumentRequest,
): Promise<ResolutionDocumentUploadLinkResponse[]> => {
  const response = await apiInstance.post<ResolutionDocumentUploadLinkResponse[]>(
    GENERATE_UPLOAD_LINK_RESOLUTION_DOCUMENT,
    data,
  );
  return response.data;
};
